<div *ngIf="isDataLoaded">
  <app-primary-nav [isActive]="isActive" (toggleActive)="changeClass($event)"
    [internalAppEnvironmentList]="appInternalEnvironmentList" [prodAppEnvironmentList]="appProductionEnvironmentList"
    [userName]="userName" class="primary-nav" [userRole]="assignedUserRole" [isGuestUser]="isGuestUser"
    (logout)="logout()">
  </app-primary-nav>

  <div class="body-cont" id="bodyContent" *ngIf="isGuestUser">
    <app-guestuser></app-guestuser>
    <footer>
      <app-footer></app-footer>
    </footer>
  </div>
  
  <div class="ds_c-wrapper" *ngIf="!isGuestUser">
    <app-secondary-nav [SideBar_Data]="sideMenu" [isClose]="isActive" [linkTo]="{ type: 'Topic'}" [currentRoute]="currentRoute" class="secondary-nav">
    </app-secondary-nav>
    <div class="body-content" id="bodyContent">
      <router-outlet class="router-flex"></router-outlet>
      <footer>
        <app-footer></app-footer>
      </footer>
    </div>
  </div>
</div>



<div *ngIf="isErrorPage">
  <app-error-screen></app-error-screen>
</div>